import Backend from "../api/Backend";
import {GifActions} from "../constants/gifActions";
import {CategoryActionType} from "../constants/categoryActionType";
import {array} from "prop-types";

export const fetchCategories = (callback) => dispatch => {

    Backend.database().ref('categories/').on('value' ,(snapshot) =>{
        let list = [array]

        snapshot.forEach(item =>  {
            list.push(item.val())
        })
        dispatch({
            type: CategoryActionType.GET_CATEGORIES,
            payload: {categories: [...list]}
        });
        callback()
    })
}


export const fetchTagsByCategory = (cat) => dispatch => {
    return new Promise((resolve, reject) => {
        Backend.database().ref('cat_tags/'+cat).once('value')
            .then((snapshot) => {
                let list = []
        
                snapshot.forEach(item =>  {
                    list.push(item.val())
                })
        
                dispatch({
                    type: CategoryActionType.GET_TAGS_BY_CATEGORIES,
                    payload: {tagesByCategories: [...list]}
                })

                resolve([...list])
            })
            .catch(error => {
                console.log(error)
                reject(error)
            })
    })
}




// WEBPACK FOOTER //
// ./src/actions/categoryAction.tsx